import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUserAnag, getRoute } from "../manager/api_manager";
import { useLingueStore } from "../../sistema/storeLingua";
import { Lingue } from "../../sistema/IT";

export default function AvpHeader({ selectedMenuId, menuCallback }) {
  const navigate = useNavigate();
  var route = getRoute();
  if (route === null) {
    navigate("/login");
  }
  const [actualLang, setActualLang] = useState("");
  const [username, setUsername] = useState("");
  const [userIsAdmin, setUserIsAdmin] = useState(false);
  const { selectedLinguaTesto, setSelectedLinguaTesto, refreshLingua } =
    useLingueStore((state) => state);
  useEffect(() => {
    let lan = localStorage.getItem("pageLang") ?? "ENG";
    setActualLang(lan);
  }, [selectedLinguaTesto]);
  useEffect(() => {
    //

    let userAnag = getUserAnag();
    if (userAnag != null) {
      setUsername(userAnag.emailUtente);
      setUserIsAdmin(userAnag.idRuolo == 1);
    }
  }, []);

  function handleLogout() {
    debugger
    console.log("handleLogout");

    localStorage.removeItem("token");
    navigate("/");
  }

  function onSelectLingua(event) {
    // const selectedLingua = Lingue.find((l) => l.key === event.target.value);
    setSelectedLinguaTesto(event.target.value);
    setActualLang(event.target.value);
  }
  //<li><a className={selectedMenuId=='dashboard' ? 'avp-menu-link-attivo' : ''} href="/">DASHBOARD</a></li>

  return (
    <div id="avp-header-container" className="clearfix">
      <div id="avp-header-container-left">
        <div id="avp-header-logo-container">
          <img id="avp-header-logo-img" style={{height:50}} src="/images/logo.png" alt="Logo" />
        </div>
        <div id="avp-header-menu-modulo">
          {route !== null && (
            <nav className="navbar navbar-default navbar-custom navbar-home">
              <ul id="avp-menu-desktop">
                {route.funzioni.some((g) => g.idFunzione === 20) && (
                  <li>
                    <a
                      className={
                        selectedMenuId == "avp" ? "avp-menu-link-attivo" : ""
                      }
                      href="/avp"
                    >
                      {selectedLinguaTesto?.AvpHeaderAvpManager}
                    </a>
                  </li>
                )}
                {route.funzioni.some((g) => g.idFunzione === 30) && (
                  <li>
                    <a
                      className={
                        selectedMenuId == "contenuti"
                          ? "avp-menu-link-attivo"
                          : ""
                      }
                      href="/contenuti"
                    >
                      {selectedLinguaTesto?.AvpHeaderContent}
                    </a>
                  </li>
                )}
                {route.funzioni.some((g) => g.idFunzione === 10) && (
                  <li>
                    <a
                      className={
                        selectedMenuId == "utenti" ? "avp-menu-link-attivo" : ""
                      }
                      href="/utenti"
                    >
                      {selectedLinguaTesto?.AvpHeaderUsers}
                    </a>
                  </li>
                )}
                {route.funzioni.some((g) => g.idFunzione === 40) && (
                  <li style={{ display: userIsAdmin ? "inline" : "none" }}>
                    <a
                      className={
                        selectedMenuId == "sistema"
                          ? "avp-menu-link-attivo"
                          : ""
                      }
                      href="/sistema"
                    >
                      {selectedLinguaTesto?.AvpHeaderSystem}
                    </a>
                  </li>
                )}
              </ul>
            </nav>
          )}
        </div>
      </div>

      <div id="avp-header-container-right">
        <div id="avp-header-profilo-box" style={{ marginRight: 20 }}>
          <select value={actualLang} onChange={onSelectLingua}>
            {Lingue.map((lingua) => {
              return (
                <option
                  key={lingua.key}
                  value={lingua.key}
                  selected={lingua.default}
                >
                  {lingua.key}
                </option>
              );
            })}
          </select>
        </div>
        <div id="avp-header-logout" onClick={() => handleLogout()}>
          <img
            id="avp-header-logout-img"
            width={30}
            src="/images/logout_icon.svg"
            alt="Logout"
          />
        </div>
        <div id="avp-header-divider">
          <img
            id="avp-header-menu-right-img"
            src="/images/vertical_divider.svg"
            alt="divider"
          />
        </div>
        <div id="avp-header-profilo-box">
          <a href="#">
            <img
              id="avp-header-profilo-img"
              src="/images/user_icon.png"
              alt="Profilo"
            />
          </a>
          <span id="avp-header-profilo-name">{username}</span>
        </div>
      </div>
    </div>
  );
}
